module.exports = __webpack_public_path__ + "img/TSY_05.b2c0e4bb.png";